import { useMemo, useState } from 'react';
import { AppModal } from '../Modal/_index';
import { onParseKeys } from './_shortcutRegistry';

const BLOCK = 'LStudio__app_shortcuts';

/*
    🔥 AYUDA DE ATAJOS

    La ventana de "?" que lista todo lo que se puede hacer con el
    teclado. Reusa AppModal: no hace falta otro diálogo con su propio
    foco y su propio cierre.

    ⚠️ TIENE BUSCADOR

    Con treinta atajos agrupados, encontrar el de guardar implica leer
    todo. El filtro busca en la descripción Y en la combinación: sirve
    tanto "guardar" como "ctrl s".
*/

export const ShortcutsHelp = ({
    isOpen,
    onClose,
    shortcuts = [],
    title = 'Atajos de teclado',
    searchPlaceholder = 'Buscar un atajo…',
    emptyLabel = 'No hay atajos que coincidan',
}) => {

    const [useQuery, setQuery] = useState('');

    const MEMO__GROUPS = useMemo(() => {

        const Q = useQuery.trim().toLowerCase();

        const FILTERED = Q
            ? shortcuts.filter((s) => (
                s.label.toLowerCase().includes(Q)
                || String(s.keys).toLowerCase().replace(/\+/g, ' ').includes(Q)
            ))
            : shortcuts;

        const MAP = new Map();

        FILTERED.forEach((s) => {
            const KEY = s.group ?? 'General';
            if (!MAP.has(KEY)) MAP.set(KEY, []);
            MAP.get(KEY).push(s);
        });

        return [...MAP.entries()];

    }, [shortcuts, useQuery]);

    return (
        <AppModal isOpen={isOpen} onClose={onClose} title={title} size="lg">

            <div className={BLOCK}>

                <input
                    type="search"
                    className={`${BLOCK}__search`}
                    value={useQuery}
                    placeholder={searchPlaceholder}
                    onChange={(e) => setQuery(e.target.value)}
                    aria-label={searchPlaceholder}
                />

                {
                    MEMO__GROUPS.length === 0
                        ? <p className={`${BLOCK}__empty`}>{emptyLabel}</p>
                        : (
                            <div className={`${BLOCK}__groups`}>
                                {
                                    MEMO__GROUPS.map(([group, items]) => (
                                        <section key={group} className={`${BLOCK}__group`}>

                                            <h3 className={`${BLOCK}__group_title`}>{group}</h3>

                                            <ul className={`${BLOCK}__list`}>
                                                {
                                                    items.map((item) => (
                                                        <li key={`${group}_${item.keys}_${item.label}`}
                                                            className={`${BLOCK}__row`} >

                                                            <span className={`${BLOCK}__label`}>{item.label}</span>

                                                            <span className={`${BLOCK}__keys`}>
                                                                {
                                                                    onParseKeys(item.keys).map((k, i) => (
                                                                        <kbd key={i} className={`${BLOCK}__kbd`}>{k}</kbd>
                                                                    ))
                                                                }
                                                            </span>

                                                        </li>
                                                    ))
                                                }
                                            </ul>

                                        </section>
                                    ))
                                }
                            </div>
                        )
                }

            </div>

        </AppModal>
    );
};

/*
    🔥 UNA TECLA SUELTA

    Para mostrar un atajo dentro de un tooltip, un menú o una pista.
*/
export const ShortcutKeys = ({ keys }) => (
    <span className={`${BLOCK}__keys`}>
        {onParseKeys(keys).map((k, i) => <kbd key={i} className={`${BLOCK}__kbd`}>{k}</kbd>)}
    </span>
);
